export class Controller {

    /** @ngInject */
    constructor(ComputersReportService) {
        this.ComputersReportService = ComputersReportService;
    }

    $onInit() {
    }

    selectedItemChanged() {
        this.ComputersReportService.computersReport
            .getComputersReport({companyId: this.companyId, appId: this.application.id})
            .$promise
            .then(computers => this.computers = computers)
    }

    formatDate(date) {
        return new Date(date).toString().slice(4, 24);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/computers-report/computers-report.controller.js